<template>
  <div>
    <div class="panel animated fadeInRightBig">
      <div class="panel-heading">
        <div class="panel-title">
          <span class="title">
            <b>Editar Usuário</b>

            <i
              class="fa fa-user-circle"
              style="float: right; margin-top: 6px; font-size: 21px"
            ></i>

            <hr />
          </span>
        </div>
      </div>

      <div class="panel-body">
        <div class="row">
          <div class="col-md-2">
            <div class="row justify-content-center">
              <div class="col-md-12">
                <img v-if="previewImage" :src="previewImage" class="addimg" />
                <img v-else :src="users.photo" width="160px" />
              </div>
              <div class="col-md-12 mt-2" align="center">
                <button
                  class="btn-sm text-center btn-addimg"
                  onclick="document.getElementById('photo').click();"
                >
                  <i class="fa fa-image"></i> Alterar a foto
                </button>
                <input
                  type="file"
                  name="photo"
                  @change="uploadImage"
                  id="photo"
                  accept="image/x-png, image/gif, image/jpeg"
                  style="display: none"
                />
              </div>
            </div>
          </div>
          <div class="col-md-10">
            <div class="row">
              <div class="col-md-4">
                <label for="name"
                  ><span class="required">*</span> Nome do Usuário</label
                >
                <input
                  type="text"
                  class="form-control"
                  name="name"
                  v-model="users.name"
                  id="name"
                  placeholder="Seu nome aqui"
                />
              </div>
              <div class="col-md-4">
                <label for="registry"
                  ><span class="required">*</span> Matrícula do Usuário
                  (QRCODE)</label
                >
                <input
                  type="text"
                  class="form-control"
                  name="registry"
                  v-model="users.registry"
                  id="registry"
                  placeholder="xxxxxxxx"
                  disabled
                />
              </div>
              <div class="col-md-4">
                <label for="email"
                  ><span class="required">*</span> E-mail do Usuário</label
                >
                <input
                  type="email"
                  class="form-control"
                  name="name"
                  v-model="users.email"
                  id="email"
                  placeholder="example@example.com.br"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-4">
                <label for="shift"><span class="required">*</span> Turno</label>
                <select
                  name="shift_id"
                  class="form-control"
                  id="shift"
                  v-model="users.shift_id"
                >
                  <option value="">Selecione uma opção</option>
                  <option
                    :value="shift.id"
                    v-for="shift in shifts"
                    v-bind:key="shift.id"
                  >
                    {{ shift.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-4">
                <label for="team_id"
                  ><span class="required">*</span> Área</label
                >
                <select
                  name="team_id"
                  class="form-control"
                  v-model="users.team_id"
                  id="team_id"
                >
                  <option value="">Selecione uma opção</option>
                  <option
                    :value="team.id"
                    v-for="team in teams"
                    v-bind:key="team.id"
                  >
                    {{ team.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-4">
                <label for="role"><span class="required">*</span> Cargo</label>
                <v-select 
                :options="roles"
                :reduce="role => role.id"
                label="name"
                v-model="users.role_id"
                ></v-select>            
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-3">
                <label for="password"
                  ><span class="required">*</span> Senha</label
                >
                <input
                  type="password"
                  name="password"
                  class="form-control"
                  id="password"
                  placeholder="***********"
                  v-model="users.password"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <form id="form" v-if="users">
        <div class="ibox-footer">
          <div class="pull-right">
            <router-link to="/users" class="btn btn-info">
              <i class="fa fa-arrow-left"></i> Voltar
            </router-link>
            <a class="btn btn-success" @click="save">
              Salvar <i class="fa fa-save"></i>
            </a>
          </div>
          <p><span class="required">*</span> Campos Obrigatórios</p>
          <div class="clearfix"></div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      previewImage: null,
      users: {
        name: "",
        email: "",
        password: "",
        registry: "",
        photo: "",
        shift_id: "",
        role_id: "",
        team_id: "",
      },
      shifts: [],
      roles: [],
      teams: [],
      errors: undefined,
    };
  },
  computed: {},
  methods: {
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImage = e.target.result;
        console.log(this.previewImage);
      };
    },
    save: function () {
      const id = this.$route.params.id;
      const api = this.$store.state.api + "users/" + id;
      const self = this;

      let form = new FormData();
      let photo = document.getElementById("photo");

      form.append("name", self.users.name);
      form.append("email", self.users.email);
      form.append("registry", self.users.registry);
      console.log(self.users.password);

      if (self.users.password) {
        form.append("password", self.users.password);
      }
      form.append("photo", photo.files[0] ? photo.files[0] : null);
      form.append("shift_id", self.users.shift_id);
      form.append("role_id", self.users.role_id);
      form.append("team_id", self.users.team_id);
      form.append("_method", "PUT");

      // if(photo.files[0]){
      //     this.updateImage();
      // }

      self.$http
        .post(api, form)
        .then((response) => {
          self.$message("Sucesso", `Usuário atualizado com sucesso`, "success");
          this.$router.push("/users");
        })
        .catch((error) => {
          self.errors = error.response.data;

          if (typeof self.errors === "object") {
            let html = "<ul>";

            $.each(self.errors, function (key, value) {
              html += "<li>" + value[0] + "</li>";
            });

            html += "</ul>";

            self.errors = html;
          }

          self.$message(null, self.errors, "error");
        });
    },
    getShifts: function () {
      let api = this.$store.state.api + "shifts";
      let self = this;

      self.$http
        .get(api)
        .then((response) => {
          self.shifts = response.data.data;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(
            null,
            "Ocorreu um erro ao carregar as informações",
            "error"
          );
        });
    },
    getRoles: function () {
      let api = this.$store.state.api + "roles/?&paginated=false";
      let self = this;

      self.$http
        .get(api)
        .then((response) => {
          self.roles = response.data.data;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(
            null,
            "Ocorreu um erro ao carregar as informações",
            "error"
          );
        });
    },
    getUsers: function () {
      let self = this;
      let id = self.$route.params.id;
      let api = self.$store.state.api + "users/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.users = response.data.data[0];
          console.log(self.users);
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    getTeams: function () {
      let api = this.$store.state.api + "teams";
      let self = this;

      self.$http
        .get(api)
        .then((response) => {
          self.teams = response.data.data;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(
            null,
            "Ocorreu um erro ao carregar as informações",
            "error"
          );
        });
    },
    updateImage: function () {
      const self = this;
      const api =
        self.$store.state.api + "users/image/update/" + self.$route.params.id;

      let form = new FormData();
      form.append("photo", document.getElementById("photo").files[0]);

      self.$http
        .post(api, form)
        .then((response) => {
          // Do nothing
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted: function () {
    this.getUsers();
    this.getShifts();
    this.getRoles();
    this.getTeams();
  },
};
</script>
<style>
.mt-2 {
  margin-top: 1rem !important;
}
.btn-addimg {
  background-color: white;
  font-size: 12px;
  border: solid 2px;
  width: 160px;
  text-align: center;
}
.addimg {
  width: 160px;
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/User/Edit.vue